import React, { useEffect } from 'react';

import { baseOptionTypeArrayToStringArray } from 'components/BaseForm/utils';
import { TableSort } from 'components/WrappedComponents/Table/types';
import { useFetchCountDossier } from 'hooks/dossiers/useFetchCountDossier';
import { useUserStore } from 'hooks/UserStoreContext';

import { useJusticeFilterContext } from '../../../../hooks/JusticeFilterStoreContext';
import { DashboardJusticeFilter } from '../types';

import Filters from './Filters/Filters';
import DownloadButton from './DownloadButton';

import './DashboardHeader.less';

interface DashboardHeaderProps<SortType extends string | undefined> {
  totalResult: number;
  filter: Partial<DashboardJusticeFilter>;
  setFilter: (value: Partial<DashboardJusticeFilter>) => void;
  sort: TableSort<SortType>;
}

function DashboardHeader<SortType extends string | undefined>({
  totalResult,
  filter,
  setFilter,
  sort,
}: Readonly<DashboardHeaderProps<SortType>>): React.ReactElement {
  const countString = `${totalResult} ${
    totalResult > 1 ? 'véhicules trouvés' : 'véhicule trouvé'
  }`;

  const user = useUserStore();
  const { fetch } = useFetchCountDossier({
    idUniteFO: user.idCorrelationUniteFO ?? undefined,
    statutDossierEnumList: filter.statut,
    idFourriereList: baseOptionTypeArrayToStringArray(filter.fourriere),
    idNatureBrancheList: filter.natureMiseEnFourriere,
    dateRangeMiseEnFourriere: filter.dateRangeMiseEnFourriere,
    numeroRecherche: filter.search,
    includeDossiersSortis: filter.includeDossiersSortis,
    actionsRequises: filter.actionsRequises,
    idMotifSortieList: [],
  });

  useEffect(fetch, [filter]);

  const [, , actionsRequises] = useJusticeFilterContext();

  return (
    <div>
      <div className="dashboard-header-fields">
        <Filters
          filter={filter}
          setFilter={setFilter}
          actionsRequises={actionsRequises}
        />
        <div className="dashboard-header-actions">
          <DownloadButton filters={filter} sort={sort} />
        </div>
      </div>
      <p className="dashboard-number-vehicules">{countString}</p>
    </div>
  );
}

export default DashboardHeader;
